import { forwardRef } from "react"

import { cn } from "../lib/utils"
import type { InputProps as BasInputProps } from "../shadcnBase/ShadcnInput"
import { Input as BaseInput, inputCn } from "../shadcnBase/ShadcnInput"

export type InputProps = BasInputProps & {
  /** if initial state should have no border */
  noBorder?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({ noBorder, className, ...p }, ref) => {
  return (
    <BaseInput
      className={cn(
        {
          "border-transparent bg-transparent transition-colors hover:bg-muted/50": noBorder,
        },
        className,
      )}
      ref={ref}
      {...p}
    />
  )
})

Input.displayName = "Input"

export { inputCn }
